module.exports = __webpack_public_path__ + "img/yiyao_kanghui_suoluetu.ba432ae6.png";